// extracted by mini-css-extract-plugin
export var image = "_010-sorting-colors-in-js-module--image--1b0Dx";